import { Component, ViewChild, AfterViewInit, OnInit, Inject, ElementRef } from '@angular/core';
import { HttpClient, HttpRequest, HttpEventType, HttpParams, HttpResponse } from '@angular/common/http';
import { MasterService } from '../services/master-service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { CommonService } from '../services/common-service';

//grid
import { jqxGridComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';
import { jqxDropDownListComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxdropdownlist';
import { jqxInputComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxinput';
import { jqxWindowComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxwindow';
import { jqxLoaderComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxloader';
import { jqxEditorComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxeditor';


@Component({
  //selector: 'app-root',
  templateUrl: '../main.component.html'
})

export class AgentPersonListComponent implements OnInit {
  public menuName = "Master";
  public titleName = "Agent";
  public clickOpen = "Rowdoubleclick($event)";
  //public rowscount = 0;
  public edited = true;
  public isSearchDate = false;
  @ViewChild('cellBeginEditLog') cellBeginEditLog: ElementRef;
  @ViewChild('cellEndEditLog') cellEndEditLog: ElementRef;
  @ViewChild('myGrid') myGrid: jqxGridComponent;
  @ViewChild('myDropDownList') myDropDownList: jqxDropDownListComponent;
  @ViewChild('myInput') myInput: jqxInputComponent;
  @ViewChild('myWindow') myWindow: jqxWindowComponent;
  @ViewChild('MyLoader') MyLoader: jqxLoaderComponent;

  delrows: Array<any> = [];
  selectedcell: any;
  errorMessage: any;
  successMessage: any;
  //agents: any = [];
  first_flg: boolean = true;
  loading_flg: boolean = true;
  //invalidInput: boolean;


  //get source
  constructor(private _masterService: MasterService, private _router: Router, public dialog: MatDialog, private _com: CommonService) {
  }

  ngOnInit() {
    //this.getAgentsDropDown();
    this.getAgentPersons();
  }

  getAgentPersons() {
    this.loading_flg = true;
    if (!(this.first_flg)) {
      this.MyLoader.open();
    }
    this._masterService.getAgentPersons(false).subscribe((data) => {
      this.source.localdata = data;
      //this.rowscount = data.length;
      this.dataAdapter.dataBind();
      if (!(this.first_flg)) {
        this.MyLoader.close();
      }
      this.first_flg = false;
      this.loading_flg = false;
    });
  }

  //getAgentsDropDown() {
  //  this._masterService.getAgentsForDropDown().subscribe((data) => {
  //    this.agentsSource.localdata = data;
  //  });
  //}

  //Popup
  Rowdoubleclick(event: any): void {
    let selectedrowindex = this.myGrid.getselectedrowindex();
    let id = this.myGrid.getrowdata(selectedrowindex).agent_person_id;
    let dialogRef = this.dialog.open(PopupAgentPersonComponent, {
      width: '1000px',
      //height: 'auto*',
      disableClose: true,//20191007 close無し
      data: {
        agent_person_id: id
      }
    });

    dialogRef.afterClosed().subscribe(
      (result) => {
        //20191008 自分のタイミングで更新するように
        //this.getAgentPersons();
      });
  }

  //tool bar
  ngAfterViewInit(): void {
    this.createButtons();
  }
  //dropDownSource: string[] = ['Id', 'Agent', 'Name', 'Phone', 'Email', 'Basic Rate', 'remarks', 'Inactive'];
  dropDownSource: string[] = ['Id', 'Name', 'Phone', 'Email', 'Basic Rate', 'Address', 'remarks', 'Inactive'];
  groups: any[] = [];
  getPagesize(): any {
    return 20;
  }
  //grid
  source: any =
    {
      datatype: 'json',
      datafields: [
        { name: 'agent_person_id', type: 'int' },
        //{ name: 'agent_id', type: 'int' },
        //{ name: 'agent_name', type: 'string' },
        { name: 'name', type: 'string' },
        { name: 'address', type: 'string' },
        { name: 'phone', type: 'string' },
        { name: 'email', type: 'string' },
        { name: 'remarks', type: 'string' },
        { name: 'basic_rate', type: 'float', cellsformat: 'c2' },
        { name: 'inactive', type: 'bool' }
      ],
      id: 'agent_person_id',
      localdata: {},
      sortcolumn: 'agent_person_id'
    };
  dataAdapter: any = new jqx.dataAdapter(this.source);

  ////dropdown 
  //sourceGender: any =
  //  {
  //    datatype: 'array',
  //    datafields: [
  //      { name: 'sort', type: 'int' },
  //      { name: 'value', type: 'string' }
  //    ],
  //    localdata: {}
  //  };
  //dataAdapterGender: any = new jqx.dataAdapter(this.sourceGender);

  //agentsSource: any =
  //  {
  //    //datatype: 'array',
  //    datatype: 'array',
  //    datafields: [
  //      { name: 'agent_id', type: 'int' },
  //      { name: 'agent_name', type: 'string' }
  //    ],
  //    localdata: {}
  //  };
  //agentsAdapter: any = new jqx.dataAdapter(this.agentsSource, { autoBind: true });

  getWidth(): any {
    return '100%';
  }
  getTotal(): any {
    return false;
  }

  //columns
  columns: any[] =
    [
      { text: 'Id', datafield: 'agent_person_id', width: '10%', align: 'right', cellsalign: 'right', columntype: 'textbox', editable: false },
      //{
      //  text: 'Agent', datafield: 'agent_id', displayfield: 'agent_name', width: '20%', columntype: 'dropdownlist', editable: false,
      //  createeditor: (row: number, column: any, editor: any): void => {
      //    // assign a new data source to the dropdownlist.
      //    //let list = ['Admin', 'Super AgentPerson', 'General AgentPerson'];
      //    editor.jqxDropDownList({ autoDropDownHeight: true, source: this.agentsAdapter, valueMember: 'agent_id', displayMember: 'agent_name', editable: false });
      //  },
      //  validation: (cell: any, value: any): any => {
      //    if (value == '') {
      //      return { result: false, message: 'Agent is required' };
      //    }
      //    return true;
      //  }
      //},
      {
        text: 'Name', datafield: 'name', width: '15%', columntype: 'textbox', maxlenght: 45, editable: false,
        validation: (cell: any, value: any): any => {
          if (value == '') {
            return { result: false, message: 'Name is required.' };
          }
          else if (value.length > 45) {
            return { result: false, message: 'Name must be less than 45 letters.' };
          }
          //let selectedrowindex = this.myGrid.getselectedrowindex();
          //var checkData = false;
          //this._masterService.checkAgentPerson(value, selectedrowindex).subscribe((data) => {
          //  if(data){
          //    if(checkData == 1){
          //      return { result: false, message: 'Same Name has already Exited.' };
          //    }
          //  }
          //}, error => console.error(error))
          //console.log("checkData:" + checkData);

          return true;
        }
      },
      {
        text: 'Phone', datafield: 'phone', width: '10%', columntype: 'textbox', editable: false,
        validation: (cell: any, value: any): any => {
          if (value.length > 45) {
            return { result: false, message: 'Phone must be less than 45 letters.' };
          }
          return true;
        }
      },
      {
        text: 'Email', datafield: 'email', width: '10%', columntype: 'textbox', editable: false,
        validation: (cell: any, value: any): any => {
          if (value.length > 45) {
            return { result: false, message: 'Email must be less than 45 letters.' };
          }
          return true;
        }
      },
      {
        text: 'Basic Rate(%)', datafield: 'basic_rate', width: '10%', cellsalign: 'right', cellsformat: 'd', columntype: 'numberinput', editable: false,
        initeditor: function (row, cellvalue, editor) {
          editor.jqxNumberInput({ digits: 5 });
        }
      },
      { text: 'Address', datafield: 'address', width: '15%', columntype: 'textbox', editable: false },
      {
        text: 'Remarks', datafield: 'remarks', width: '20%', columntype: 'textbox', editable: false,
        validation: (cell: any, value: any): any => {
          if (value.length > 200) {
            return { result: false, message: 'Remarks must be less then 200 letters.' };
          }
          return true;
        }
      },
      { text: 'Inactive', datafield: 'inactive', width: '10%', columntype: 'checkbox', twostatecheckbox: true, align: 'center', editable: false}
    ];

  groupsrenderer(text, group, expanded, data): any {
   var color;
    switch (data.level) {
      case 0:
        color = '#B0BEC5';
        break;
      case 1:
        color = '#CFD8DC';
        break;
      case 2:
        color = '#ECEFF1';
        break;
      case 3:
        color = '#EEEEEE';
        break;
      case 4:
        color = '#F5F5F5';
        break;
      case 5:
        color = '#FAFAFA';
        break;
    } 
    //return '<div style="width: 100%; height: 100%; background-color: ' + color + '; color:Black; line-height:30px;"><span style="font-weight:bold; vertical-align: middle;">' + text + '</span></div>';

    return '<div style="width: 100%; height: 100%; background-color: #CFD8DC; color:Black; line-height:30px;"><span style="font-weight:bold; vertical-align: middle;">' + text + '</span></div>';
  }

  //add row
  //generatedata(): any {
  //  let row = {};
  //  row['agent_person_id'] = 0;
  //  row['agent_name'] = "";
  //  row['name'] = "";
  //  row['phone'] = "";
  //  row['email'] = "";
  //  row['basic_rate'] = 0;
  //  row['remarks'] = "";
  //  row['inactive'] = false;

  //  return row;
  //}

  //tool buttons
  createButtonsContainers(statusbar: any): void {
    let buttonsContainer = document.createElement('div');
    buttonsContainer.style.cssText = 'overflow: hidden; position: relative; margin: 5px;';
    let addButtonContainer = document.createElement('div');
    //let deleteButtonContainer = document.createElement('div');
    let reloadButtonContainer = document.createElement('div');
    //let searchButtonContainer = document.createElement('div');
    //let saveButtonContainer = document.createElement('div');
    addButtonContainer.id = 'addButton';
    //deleteButtonContainer.id = 'deleteButton';
    reloadButtonContainer.id = 'reloadButton';
    //searchButtonContainer.id = 'searchButton';
    //saveButtonContainer.id = 'saveButton';
    addButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    //deleteButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    reloadButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    //searchButtonContainer.style.cssText = 'float: left; margin-left: 5px;';
    //saveButtonContainer.style.cssText = 'float: right; margin-right: 5px;';
    addButtonContainer.className = 'btn btn-default';
    //deleteButtonContainer.className = 'btn btn-default';
    reloadButtonContainer.className = 'btn btn-default';
    //searchButtonContainer.className = 'btn btn-default';
    //saveButtonContainer.className = 'btn btn-default';
    buttonsContainer.appendChild(addButtonContainer);
    //buttonsContainer.appendChild(deleteButtonContainer);
    buttonsContainer.appendChild(reloadButtonContainer);
    //buttonsContainer.appendChild(searchButtonContainer);
    //buttonsContainer.appendChild(saveButtonContainer);
    statusbar[0].appendChild(buttonsContainer);
  }

  //create tool buttons
  createButtons(): void {
    let addButtonOptions = {
      width: 40, height: 25,
      theme: "material",
      value: "<span class='glyphicon glyphicon-plus' style='color:darkseagreen;' title='Add'></span>"
    }
    let addButton = jqwidgets.createInstance('#addButton', 'jqxButton', addButtonOptions);
    //let deleteButtonOptions = {
    //  width: 40, height: 25,
    //  theme: "material",
    //  value: "<span class='glyphicon glyphicon-remove' style='color:indianred;' title='Delete'></span>"
    //}
    //let deleteButton = jqwidgets.createInstance('#deleteButton', 'jqxButton', deleteButtonOptions);
    let reloadButtonOptions = {
      width: 40, height: 25,
      theme: "material",
      value: "<span class='glyphicon glyphicon-refresh' style='color:darkblue;' title='Reload'></span>"
    }
    let reloadButton = jqwidgets.createInstance('#reloadButton', 'jqxButton', reloadButtonOptions);
    //let searchButtonOptions = {
    //  width: 40, height: 25,
    //  theme: "material",
    //  value: "<span class='glyphicon glyphicon-search' style='color:slategrey;' title='Find'></span>"
    //}
    //let searchButton = jqwidgets.createInstance('#searchButton', 'jqxButton', searchButtonOptions);
    //let saveButtonOptions = {
    //  width: 40, height: 25,
    //  theme: "material",
    //  value: "<span class='glyphicon glyphicon-floppy-disk' style='color:#2E7D32;' title='Save'></span>"
    //}
    //let saveButton = jqwidgets.createInstance('#saveButton', 'jqxButton', saveButtonOptions);

    // add new row.
    addButton.addEventHandler('click', (event: any): void => {
      let id = 0;
      let dialogRef = this.dialog.open(PopupAgentPersonComponent, {
        width: '900px',
        //height: 'auto*',
        disableClose: true,//20191007 close無し
        data: {
          agent_person_id: id
        }
      });
      dialogRef.afterClosed().subscribe(
        (result) => {
          //20191008 自分のタイミングで更新するように
          //this.getAgentPersons();
        });
    });
    // delete selected row.
    //deleteButton.addEventHandler('click', (event: any): void => {
    //  let selectedrowindex = this.myGrid.getselectedrowindex();
    //  let rowscount = this.myGrid.getdatainformation().rowscount;
    //  let id = this.myGrid.getrowid(selectedrowindex);
    //  this.myGrid.deleterow(id);
    //  this.delrows.push(id);
    //});
    // reload grid data.
    reloadButton.addEventHandler('click', (event: any): void => {
      this.getAgentPersons();
      this.delrows = [];
      this.selectedcell = null;
    });
    // search for a record.
    //searchButton.addEventHandler('click', (event: any): void => {
    //  this.myWindow.open();
    //  this.myWindow.move(60, 60);
    //});
    // save records.
    //saveButton.addEventHandler('click', (event: any): void => {
    //  this.errorMessage = null;
    //  this.successMessage = 'You have successfully saved the data.';

    //  //confirm changes
    //  let selectedrowindex = this.myGrid.getselectedrowindex();
    //  this.myGrid.endcelledit(selectedrowindex, this.selectedcell, false);

    //  for (var i = 0; i < this.myGrid.getrows().length; i++) {
    //    let agent = this.myGrid.getrowdata(i);
    //    if (agent.name == ""
    //      || agent.name.length > 45
    //      || agent.phone.length > 45
    //      || agent.email.length > 45
    //      || agent.basic_rate == 0
    //      || agent.agent_id == null
    //      || agent.agent_id == 0
    //      || agent.remarks.length > 200) {
    //      this.errorMessage = "Input is invalid. Please check the data.";
    //      this.successMessage = null;
    //      return;
    //    }
    //  }
      
    //  let rows = this.myGrid.getrows();

    //  rows.forEach(agent_person => {
    //  console.log("agent_person.agent_person_id:" + agent_person.agent_person_id);
    //    if (agent_person.agent_person_id == 0) {
    //      this._masterService.addAgentPerson(agent_person)
    //        .subscribe(
    //          data => {
    //            //this.getAgentPersons();
    //            let index = this.myGrid.getrowboundindexbyid(agent_person.agent_person_id);
    //            agent_person.agent_person_id += data;
    //            this.myGrid.setcellvalue(index, "agent_person_id", data);
    //        },
    //        error => {
    //          this.successMessage = null;
    //          if (error._body != null) {
    //            this.errorMessage += "Some data have not been saved. " + error._body;
    //          } else {
    //            this.errorMessage += error;
    //          }
    //        })
    //    }
    //    else {
    //      this._masterService.updateAgentPerson(agent_person)
    //        .subscribe(
    //          data => {
    //          //this.getAgentPersons();
    //        },
    //        error => {
    //          this.successMessage = null;
    //          if (error._body != null) {
    //            this.errorMessage += "Some data have not been saved. " + error._body;
    //          } else {
    //            this.errorMessage += error;
    //          }
    //        })
    //    }
    //  });
    //  this.delrows.forEach(agent_person_id => {
    //    if (agent_person_id != 0) {
    //      this._masterService.deleteAgentPerson(agent_person_id).subscribe(
    //        data => {
    //          //this.getAgentPersons();
    //          if (data != 1) {
    //            this.errorMessage += "Data has not been found : ID " + agent_person_id;
    //          }
    //        },
    //        error => {
    //          this.successMessage = null;
    //          if (error._body != null) {
    //            this.errorMessage += "Some data have not been saved. " + error._body;
    //          } else {
    //            this.errorMessage += error;
    //          }
    //        })
    //    }
    //  });
    //  this.delrows = [];
    //  this.selectedcell = null;
    //});
  }

  //find button
  findBtnOnClick(): void {
    this.myGrid.clearfilters();
    let searchColumnIndex = this.myDropDownList.selectedIndex();
    let datafield = '';
    switch (searchColumnIndex) {
      case 0:
        datafield = 'agent_person_id';
        break;
      //case 1:
      //  datafield = 'agent_name';
      //  break;
      case 1:
        datafield = 'name';
        break;
      case 2:
        datafield = 'phone';
        break;
      case 3:
        datafield = 'email';
        break;
      case 4:
        datafield = 'basic_rate';
        break;
      case 5:
        datafield = 'address';
        break;
      case 6:
        datafield = 'remarks';
        break;
      case 7:
        datafield = 'inactive';
        break;
    }
    let searchText = this.myInput.val();
    let filtergroup = new jqx.filter();
    let filter_or_operator = 1;
    let filtervalue = searchText;
    let filtercondition = 'contains';
    let filter = filtergroup.createfilter('stringfilter', filtervalue, filtercondition);
    filtergroup.addfilter(filter_or_operator, filter);
    this.myGrid.addfilter(datafield, filtergroup);
    // apply the filters.
    this.myGrid.applyfilters();
  }

  //clear btn
  clearBtnOnClick(): void {
    this.myGrid.clearfilters();
  }

  //edit function
  rowValues: string = '';
  myGridOnCellBeginEdit(event: any): void {
    let args = event.args;
    this.selectedcell = args.datafield;
  };
  myGridOnCellEndEdit(event: any): void {
  };

  //print pdf
  btnOnClick() {
    let gridContent = this.myGrid.exportdata('html');
    let newWindow = window.open('', '', 'width=800, height=500'),
      document = newWindow.document.open(),
      pageContent =
        '<!DOCTYPE html>\n' +
        '<html>\n' +
        '<head>\n' +
        '<meta charset="utf-8" />\n' +
        '<title>Agent Person - Report</title>\n' +
        '</head>\n' +
        '<body>\n' + gridContent + '\n</body>\n</html>';
    document.write(pageContent);
    document.close();
    newWindow.print();
  };

  //export excel
  excelBtnOnClick() {
    this.myGrid.exportdata('xls', 'Agent Person');
  };

  onPageChanged(): void {
    this.myGrid.expandallgroups();
  }

  //Close Message
  closeSuccessMessage() {
    this.successMessage = null;
  }
  closeErrorMessage() {
    this.errorMessage = null;
  }
}


//****************************************************
// Popup
//****************************************************

@Component({
  selector: 'app-popup-agent-person',
  templateUrl: 'popup-agent-person.component.html',
  styleUrls: ['./master-popup.component.css'],
})
export class PopupAgentPersonComponent implements OnInit {
  title: string = "(Create)";
  Form: FormGroup;
  errorMessage: any;
  successMessage: any;
  selectedcell: any;
  delrows: Array<any> = [];
  //agentList: Array<any> = [];
  searchedList: Array<any> = [];
  user: any;

  constructor(
    public dialogRef: MatDialogRef<PopupAgentPersonComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _masterService: MasterService,
    private _authService: AuthService,
    private _fb: FormBuilder, private _com: CommonService
  ) {
    var today = new Date();
    var todayStr = this._com.getDateTime(new Date());
    this.user = this._authService.getAuthLoginName();
    this.Form = this._fb.group({
      agent_person_id: 0,
      agent_id: 0,
      //agent_name: ['', Validators.required],
      agent_name: '',
      name: ['', Validators.required],
      phone: '',
      address: '',
      email: '',
      basic_rate: 0,
      remarks: '',
      updated_by: this.user,
      updated_date: todayStr,
      inactive: false
    })
  }

  ngOnInit() {
    this.getAgentPersonById(this.data.agent_person_id);
    //this.getDropDownList();
  }

  ngAfterViewInit(): void {
  }

  //getDropDownList() {
  //  //Agent
  //  this._masterService.getAgents(true)
  //    .subscribe(data => {
  //      this.agentList = data;
  //    });
  //}
  getAgentPersonById(id) {
    if (id > 0) {
      this.title = '(Edit/View)'
      this._masterService.getAgentPersonById(id)
        .subscribe(
          res => {
            this.Form.setValue(res);
            //this.onKey(res.agent_name);
          },
          error => this.errorMessage = error
        );
    }
  }

  getWidth(): any {
    return '100%';
  }

  getHeight(): any {
    return '70%';
  }

  //Save Data
  saveAgentPerson() {
    //check form
    if (this.Form.invalid) {
      this.errorMessage = 'Please enter all required fields.';
      return;
    }

    this.errorMessage = null;
    this.successMessage = null;
    var today = new Date();
    var todayStr = this._com.getDateTime(new Date());
    this.Form.value.updated_by = this.user;
    this.Form.value.updated_date = todayStr;
    if (this.agent_person_id.value == 0) {
      this._masterService.addAgentPerson(this.Form.value)
        .subscribe(
          data => {
            if (data > 0) {
              this.successMessage = "You have successfully added the data.";
              this.getAgentPersonById(data);
            } else {
              this.errorMessage = "Failed to save the data. ";
            }
          },
          error => {
            this.successMessage = null;
            if (error != null) {
              this.errorMessage = error._body;
            }
            else {
              this.errorMessage = "Failed to save the data. ";
            }
          });
    }
    else {
      this._masterService.updateAgentPerson(this.Form.value)
        .subscribe(
          data => {
            if (data > 0) {
              this.successMessage = "You have successfully updated the data.";
              this.getAgentPersonById(data);
            } else {
              this.errorMessage = "Failed to update the data. ";
            }
          },
          error => {
            this.successMessage = null;
            if (error != null) {
              this.errorMessage = error._body;
            }
            else {
              this.errorMessage = "Failed to update the data. ";
            }
          });
    }
  }

  //Delete Data
  deleteAgentPerson() {
    if (!confirm("Are you sure you want to delete this data?")) {
      console.log('no');
      return;
    }

    if (this.agent_person_id.value != 0) {

      let id = this.agent_person_id.value;

      this._masterService.deleteAgentPerson(id)
        .subscribe(
          data => {
            if (data == 1) {
              this.dialogRef.close();
            }
            else {
              this.errorMessage = ' Failed to delete the data.';
            }
          },
          error => {
            if (error != null) {
              this.errorMessage = error._body;
            }
            else {
              this.errorMessage = "Failed to delete the data. ";
            }
          }
        )
    };
  }

  //agentOnSelect(event: any): void {
  //  let value = event.value;
  //  if (value > 0) {
  //    this._masterService.getAgentById(value)
  //      .subscribe(
  //        data => {
  //          this.agent_id.setValue(data.agent_id);
  //          this.agent_name.setValue(data.name);
  //        });
  //  }
  //  else {
  //    this.agent_id.setValue(0);
  //    this.agent_name.setValue(null);
  //  }
  //}

  //// Receive user input and send to search method**
  //onKey(value) {
  //  this.searchedList = [];
  //  if (typeof value != "undefined" && value != null && value != "") {
  //    this._masterService.getListAgentsForDropDownSearchList(value)
  //      .subscribe(
  //        res => {
  //          this.searchedList = res;
  //          //this.searchedList.push(res); //error
  //        },
  //        error => this.errorMessage = error
  //      );
  //  } else {
  //    this.agent_id.setValue(0);
  //    this.agent_name.setValue("");
  //  }
  //}

  //Close Message
  closeSuccessMessage() {
    this.successMessage = null;
  }
  closeErrorMessage() {
    this.errorMessage = null;
  }

  get agent_person_id() { return this.Form.get('agent_person_id'); }
  get name() { return this.Form.get('name'); }
  get phone() { return this.Form.get('phone'); }
  get email() { return this.Form.get('email'); }
  get remarks() { return this.Form.get('remarks'); }
  get address() { return this.Form.get('address'); }
  get basic_rate() { return this.Form.get('basic_rate'); }
  get agent_id() { return this.Form.get('agent_id'); }
  get agent_name() { return this.Form.get('agent_name'); }
  get inactive() { return this.Form.get('inactive'); }
  get updated_by() { return this.Form.get('updated_by'); }
  get updated_date() { return this.Form.get('updated_date'); }
}




// WEBPACK FOOTER //
// ./src/app/master/agent-person-list.component.ts